/** @jsx jsx */
import { jsx } from 'theme-ui'

import styled from '@emotion/styled'
import { Box, Flex } from 'theme-ui'

import Img from 'gatsby-image'
import ProductCard from '../product/ProductCard'

const Wrapper = styled.section`
  position: relative;
  min-height: 300px;
  height: auto;
  @media (min-width: ${props => props.theme.responsive.small}) {
    height: ${props => props.height || 'auto'};
  }
`

const LifeStyleProduct = props => {
  return (
    <Flex
      sx={{
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: props.reverse ? 'row-reverse' : 'row',
      }}
    >
      <Flex
        sx={{
          width: ['100%', '100%', null, '50%'],
          flexDirection: 'column',
          justifyContent: 'center',
          p: ['1rem', '1rem', '1rem'],
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <ProductCard
          sx={{ width: ['45%'] }}
          hideSwatches={true}
          {...props.productVariant.product}
        />
      </Flex>

      <Flex
        sx={{
          width: ['100%', '100%', null, '50%'],
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Img
            sx={{
              margin: 'auto',
              maxHeight: props.fullHeightImage ? '640px' : '428px',
              width: '100%',
            }}
            fluid={props.image.fluid}
            alt={props.title}
          />
        </Box>
      </Flex>
    </Flex>
  )
}

export default LifeStyleProduct
